@if (store) {
<p class="s1 col-1">{{store.data?.store_name}}</p>
<p sizeClass="SM: p2, XL: p1"
   class="col-11 m-t-1">{{store.data?.address}},</p>
<p sizeClass="SM: p2, XL: p1"
   class="col-11 m-b-1">{{store.data?.city}}, {{store.data?.postcode}}</p>

<div class="flex flex-justify-between">
    <page-store-finder-store-status [store]="store"></page-store-finder-store-status>

    @if (store.data?.distance) {
    <span class="p-b-1 inline-block col-11 c1">
        <span>{{store.getDistance(true)}}</span> miles
    </span>
    }
</div>
}